<template>
  <div>
    <h5 class="proxima-blue-text">
      {{ props.title }}
    </h5>
    <p class="text-sm proxima-blue-paragraph">
      {{ props.contents }}
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  contents: {
    type: String,
    default: null,
  },
});
</script>
